/**
 * useSecretDetails Hook
 *
 * Custom React Query hook for fetching a single secret with details.
 * Note: Secret values are never returned via API.
 */

import { useQuery } from '@tanstack/react-query';
import { secretService } from '../../../api/secret.service';

/**
 * Hook for fetching secret details
 * @param tenantId - Tenant ID
 * @param secretId - Secret ID
 */
export const useSecretDetails = (tenantId: string, secretId: string) => {
  return useQuery({
    queryKey: ['secrets', tenantId, secretId],
    queryFn: () => secretService.getSecret(tenantId, secretId),
    enabled: !!tenantId && !!secretId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};
